(() => {
  const initShell = (shell) => {
    if (!shell || shell.dataset.nfb2bInitialized === 'true') return;
    shell.dataset.nfb2bInitialized = 'true';

    const form = shell.querySelector('[data-nfb2b-form]');
    if (!form) return;

    const overview = form.querySelector('[data-overview]');
    const formView = form.querySelector('[data-form-view]');
    const steps = [...form.querySelectorAll('[data-step]')];
    const timeline = [...shell.querySelectorAll('.nfb2b-project__timeline-step')];
    const openButtons = [...shell.querySelectorAll('[data-open-step]')];
    const showOverviewButtons = [...shell.querySelectorAll('[data-show-overview]')];

    if (!steps.length || !overview || !formView) return;

    let currentStep = 0;

    const setTimeline = (index) => {
      timeline.forEach((item, itemIndex) => {
        item.classList.toggle('is-active', itemIndex === index);
        if (itemIndex === index) {
          item.setAttribute('aria-current', 'step');
        } else {
          item.removeAttribute('aria-current');
        }
      });
    };

    const showOverview = (shouldFocus = false) => {
      overview.hidden = false;
      formView.hidden = true;
      setTimeline(0);

      if (shouldFocus) {
        shell.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    };

    const showStep = (index, shouldFocus = false) => {
      currentStep = Math.max(0, Math.min(index, steps.length - 1));
      overview.hidden = true;
      formView.hidden = false;

      steps.forEach((step, stepIndex) => {
        step.hidden = stepIndex !== currentStep;
      });

      setTimeline(currentStep);

      if (shouldFocus) {
        const legend = steps[currentStep].querySelector('legend');
        if (legend) {
          legend.setAttribute('tabindex', '-1');
          legend.focus({ preventScroll: true });
        }

        if (window.matchMedia('(max-width: 749px)').matches) {
          shell.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      }
    };

    const validateStep = () => {
      const controls = [...steps[currentStep].querySelectorAll('input, select, textarea')]
        .filter((control) => !control.disabled);
      const invalid = controls.find((control) => !control.checkValidity());

      if (invalid) {
        invalid.reportValidity();
        return false;
      }

      return true;
    };

    openButtons.forEach((button) => {
      button.addEventListener('click', () => {
        showStep(Number(button.dataset.openStep || 0), true);
      });
    });

    showOverviewButtons.forEach((button) => {
      button.addEventListener('click', () => showOverview(true));
    });

    form.addEventListener('click', (event) => {
      const next = event.target.closest('[data-next]');
      const prev = event.target.closest('[data-prev]');

      if (next && validateStep()) {
        showStep(currentStep + 1, true);
      }

      if (prev) {
        if (currentStep === 0) {
          showOverview(true);
        } else {
          showStep(currentStep - 1, true);
        }
      }
    });

    const hasErrors = form.querySelector('.nfb2b-project__errors');
    if (hasErrors) {
      showStep(steps.length - 1);
    } else {
      showOverview();
    }
  };

  const initAll = (root = document) => {
    root.querySelectorAll('[data-nfb2b-shell]').forEach(initShell);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll());
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();
